import { useState } from 'react';
import Sheet from './Sheet';
import Calendar from './Calendar';
import Icon from './Icon';
import { longDate, parseISODate, shortDate } from '../lib/dates';

// "26/10/2026", or "Thứ Hai, 26/10/2026" with the weekday.
const display = (iso, weekday) => {
  const year = parseISODate(iso).getFullYear();
  return `${weekday ? longDate(iso) : shortDate(iso)}/${year}`;
};

// Where a birthday picker opens when empty: the years around someone in their late twenties.
export const DOB_DEFAULT_MONTH = `${new Date().getFullYear() - 28}-01-01`;

// A date input that opens the app's calendar (the same one as on Today) in a sheet, instead of the
// phone's own picker. `value`/`onChange` use "YYYY-MM-DD"; `title` names the sheet; `min`/`max` limit
// the days; `defaultMonth`/`startView` choose where an empty picker opens (e.g. years, for a birthday).
export default function DateField({
  id, value, onChange, title = 'Chọn ngày', placeholder = 'Chọn ngày', min, max, weekday = false,
  defaultMonth, startView, className = '',
}) {
  const [open, setOpen] = useState(false);
  const pick = (iso) => {
    onChange(iso);
    setOpen(false);
  };
  return (
    <>
      <button id={id} type="button" aria-haspopup="dialog" onClick={() => setOpen(true)}
        className={`input flex h-11 w-full items-center justify-between gap-2 rounded-[14px] border-line text-base ${className}`}>
        <span className={`tabular ${value ? '' : 'text-muted'}`}>{value ? display(value, weekday) : placeholder}</span>
        <Icon name="calendar" className="size-5 shrink-0 text-muted" />
      </button>
      <Sheet open={open} onClose={() => setOpen(false)} title={title}>
        <Calendar value={value} onSelect={pick} min={min} max={max} defaultMonth={defaultMonth}
          startView={value ? 'days' : startView} />
      </Sheet>
    </>
  );
}
